module.exports = __webpack_public_path__ + "img/small-5.4176a98b.webp";